import { Needs } from '@/pages/members/pages/Onboarding/steps/WhatDoYouNeedHelpWithStep/types';
import { Substance } from '@/types/substance';
import { SelectOption } from '@/ui/members/components/form/SelectDialog/types';

const getSubstanceUseSubstances = (primarySubstanceChoices: Substance[] = []) =>
  primarySubstanceChoices
    .filter((substance) => substance.drug_category !== Needs.MentalHealth)
    .map((substance: Substance): SelectOption => ({
      label: substance.name,
      value: substance.name
    }));

const getMentalHealthSubstances = (primarySubstanceChoices: Substance[] = []) =>
  primarySubstanceChoices
    .filter((substance) => substance.drug_category === Needs.MentalHealth)
    .map((substance: Substance): SelectOption => ({
      label: substance.name,
      value: substance.name
    }));

export const groupTreatableSubstancesByNeeds = (
  treatableSubstances: Substance[] = [],
  primarySubstanceChoices: Substance[] = []
) => {
  if (treatableSubstances.length === 0) {
    return {
      [Needs.MentalHealth]: getMentalHealthSubstances(primarySubstanceChoices),
      [Needs.SubstanceUse]: getSubstanceUseSubstances(primarySubstanceChoices)
    };
  }

  return treatableSubstances.reduce(
    (result, substance) => {
      const substanceForSelectOption = {
        value: substance.name,
        label: substance.name
      };
      if (substance.drug_category === Needs.MentalHealth) {
        result.mental_health.push(substanceForSelectOption);
      } else {
        result.substance_use.push(substanceForSelectOption);
      }
      return result;
    },
    {
      [Needs.MentalHealth]: [] as SelectOption[],
      [Needs.SubstanceUse]: [] as SelectOption[]
    }
  );
};
